/* eslint-disable  @typescript-eslint/no-explicit-any */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useRef, useState } from 'react'; // we need this to make JSX
import { Grid } from '@mui/material';
import { useHistory } from 'react-router';
import { Logger } from '../../../../libs/utils/logger';
import HttpClient from '../../../../libs/utils/httpClient';
import { IFileInfo } from '../../../Data/FxAgreementLinkCard';
import { getLastFourDigits, kycSignupFormValidator } from '../../../Utils/CommonBaseClass';
import { convertToPhoneRequestFormat, convertToPhoneDisplayFormat, updateComponentData, fetchDataFromState, updateComponentParams, callAPI, Method } from '../../../Utils/CommonBaseClass';
import { ReviewAndSubmitSignup } from '../Common/ReviewAndSubmitSignup';
import { getCustomerUrl, processAPIResponse, pushGTM, useIsMobileOrTabletScreen } from '../../../../libs/utils/utils';
import { getKey, removeCookieCustom, setKey } from '../../../../libs/utils/storageManager';
import { RegisterComponent } from '../../../../libs/saga/dataSaga';
import FxSnackBar from '../../../Utils/fx-snack-bar';
import { useDispatch, useSelector } from 'react-redux';
import { ICardData } from '../Common/ReviewInfoCard';
import { JointTenancyIdentificationSignUp } from './JointTenancyIdentificationSignUp';
import { JointTenancyCoOwnerCard } from './JointTenancyCoOwner/JointTenancyCoOwnerCard';
import { JointTenancySignUpLeftBar } from './JointTenancySignUpLeftBar';
import { setLocalStorage } from '../../../../libs/utils/cacheHandler';
import { SignUpIndividualDetailsRef } from '../Individual/SignUpIndividualDetails';
import { getAutosavedDataFromOnboardingFormDataApi, unflattenObject, updateOnboardingFormData } from '../../../../libs/utils/autoSaveField';
import { buildOwnerRequest, mergeBeneficialOwners, signUpJointTenancy } from './JointTenenancyUtilServices/jointTenancyUtils';
import { updateCustomerKycJointOwnersData } from './JointTenenancyUtilServices/updateJointOwnerState';

const httpClient = HttpClient.getClient();

/**
 * Component: Signup Joint 
 * Usage: User signup page
 */

Logger.debug("JointTenancySignUp.tsx", "SignUp initializing")

export const JointTenancySignUp: React.FC<any> = React.memo(
    (props) => {
        let context : any;
        ({ context, props } = RegisterComponent(props));
        const { isLoading, step, paymentIdDetailReq, isUpdateContactRequest, initialIndData } = props;
        const history = useHistory();
        const dispatch = useDispatch();
        const isSmallScreen = useIsMobileOrTabletScreen();
        const jtCoOwnerForm = useRef<SignUpIndividualDetailsRef>(null);
        const jtIdentificationForm = useRef<SignUpIndividualDetailsRef>(null);
        const [hasFetchedOnboardingData, setHasFetchedOnboardingData] = useState(false);
        /**
         * UseEffect hook resets the parameters
         */
        useEffect(() => {
          updateComponentParams(dispatch, props.id, { isLoading: false, step: 1, fetchIds: false, formReq: undefined, primaryOwnerData: undefined, paymentIdDetailData: undefined, paymentIdDetailReq: undefined,  isUpdateContactRequest: false,  initialIndData: false, beneficialCoOwnerData: undefined });
        },[dispatch,props.id,])
        /**
         * Method fetches data from the state
         */
        const jointOwnerState = useSelector((state: any) =>
            fetchDataFromState(state, 'customer-kyc-joint-owners-data')
        );

        /**
        checking customer info is present on the customer get api or not.If data is present then calling method 'setInitialData' to prepolutae the information
         */
        useEffect(() => {
            if(context?.data?.body){
                setInitialData();
            }
        },[context?.data?.body])

        /**
         * This useEffect is used to call the GET Onboardding Data API
         */
        useEffect(() => {
            if (!hasFetchedOnboardingData) {
                setHasFetchedOnboardingData(true);
                fetchOnboardingFormData();
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        },[props?.initialIndData, props?.beneficialCoOwnerData]);

        /**
         * This method fetches the previously saved data from the GET autoSaved API
         * and sets the values in the form fields
         */
        const fetchOnboardingFormData = async () => {
            try {
                const response = await getAutosavedDataFromOnboardingFormDataApi();

                // Guard clause: Exit early if no valid data is received
                if (!response?.data?.flatFields) {
                    console.log('No autosaved data or flatFields found.');
                    return;
                }

                const { flatFields } = response.data;

                // Unflatten and format the auto-saved data
                const objectFormatData = unflattenObject(flatFields);
                const formattedAutoSavedData = getBODetailsDataFromApi(objectFormatData, 'autoSavedData');

                // Merge the auto-saved data with existing joint owner data
                // We slice from index 1 assuming the first item might be a primary owner or header
                const mergedBeneficialOwners = mergeBeneficialOwners(
                    formattedAutoSavedData.slice(1) ?? [],
                    jointOwnerState?.data?.beneficialCoOwnerData ?? [] // Ensure a default empty array
                );

                // Update the component's parameters with the merged data
                updateComponentParams(dispatch, props?.id, { autoSavedData: mergedBeneficialOwners });

                // Process all beneficial owners if valid merged data exists
                if (Array.isArray(mergedBeneficialOwners) && mergedBeneficialOwners.length > 0) {
                    processAllBeneficialOwners(mergedBeneficialOwners);
                } else {
                    console.log('No beneficial owners to process after merging.');
                }

            } catch (error) {
                console.error('Error fetching or processing onboarding form data:', error);
            }
        };

       


        /**
         * This method creates the component friendly formats of the 
         * BO data to save in the 'customer-kyc-data' state
         * @param ownerArray 
         */
        const processAllBeneficialOwners = async (ownerArray: any[]) => {
            // Exit early if the input array is empty or not an array
            if (!Array.isArray(ownerArray) || ownerArray.length === 0) {
                console.warn('processAllBeneficialOwners received an empty or invalid ownerArray.');
                return;
            }

            const processedData: any[] = [];
            const requestPayloads: any[] = [];

            // Use Promise.all for parallel processing of buildOwnerRequest calls
            const results = await Promise.all(
                ownerArray.map(async (item) => {
                    return buildOwnerRequest({ ...item });
                })
            );

            // After all promises resolve, extract data and requests
            for (const result of results) {
                processedData.push(result.data);
                requestPayloads.push(result.req);
            }

            const updatedJointOwnerData = {
                ...jointOwnerState?.data, // Spread existing data to maintain other properties
                beneficialCoOwnerData: processedData,
                beneficialCoOwnerReq: requestPayloads,
            };

            // Update the global state with the new data
            updateCustomerKycJointOwnersData(dispatch, updatedJointOwnerData);

        };

          
        /**
         * method used to set data on form while page loading
         */
        const setInitialData= ()=> {
            const primaryOwnerData = getCustomerDetailsDataFromApi(context?.data?.body);
            const beneficialOwnerData = getBODetailsDataFromApi(context?.data?.body );
            const formReqCopy = signUpJointTenancy({ details: primaryOwnerData })
            const jointOwnerStateCopy = {...jointOwnerState?.data};
            validatejtIdentificationForm(primaryOwnerData);
            beneficialOwnerData?.length>0&&setKey('jtCoOwnerForm', 'valid'); ;
            let primaryOwnerObj;
            if(jointOwnerStateCopy){
                if(primaryOwnerData){
                    const ssn=jointOwnerStateCopy['primaryOwnerData']?.['ssn'];
                    const itin=jointOwnerStateCopy['primaryOwnerData']?.['itin'];
                    primaryOwnerData.ssn = primaryOwnerData?.ssn ? primaryOwnerData?.ssn : ssn;
                    primaryOwnerData.itin = primaryOwnerData?.itin ? primaryOwnerData?.itin : itin;
                    jointOwnerStateCopy['primaryOwnerData'] = primaryOwnerData;
                }

                if(beneficialOwnerData){
                    jointOwnerStateCopy['beneficialCoOwnerData'] = beneficialOwnerData;
                }
            }
            else{
                primaryOwnerObj = { primaryOwnerData: primaryOwnerData, beneficialCoOwnerData: beneficialOwnerData  }
            }

          updateComponentData(dispatch, 'customer-kyc-joint-owners-data', { ...jointOwnerStateCopy || primaryOwnerObj })

          //Merging the 2 Co-owner data-sets into one single entity
          const mergedData = mergeBeneficialOwners(
                props?.autoSavedData ?? [],
                beneficialOwnerData
          );

        //updating the autoSavedData property with the updated data
        updateComponentParams(dispatch, props?.id, { autoSavedData: mergedData });

        if(Array.isArray(mergedData) && mergedData?.length > 0)
            processAllBeneficialOwners(mergedData);

          updateComponentParams(dispatch, props.id, { primaryOwnerData: primaryOwnerData, initialIndData: true, formReq: formReqCopy, beneficialCoOwnerData: beneficialOwnerData  })

        }

        /**
         * Validates the primary owner data against required fields and updates the form validation status.
         * @param primaryOwnerData {Object} The primary owner data to be validated.
         */
        const validatejtIdentificationForm = (primaryOwnerData: any,) => {
            const taxIdentifier = primaryOwnerData?.ssn ? 'ssn' : 'itin';
            const primaryOwnerRequiredFields = ['addressLine1', 'city', 'dob', taxIdentifier, 'email', 'firstName', 'lastName', 'mobilePhone', 'state', 'zip'];
           kycSignupFormValidator(primaryOwnerData, primaryOwnerRequiredFields, 'jtIdentificationForm');
        }
               
        /**
         * method used to convert customer get  api response in form data format
         * @param data :data from api response
         * @returns
         */
        const getBODetailsDataFromApi = (data: any, origin?: any) => {   
            let ownerArray:any = data?.owners
            /**
             *  This line creates a new array from `ownerArray` and ensures:
             * - Any `null`, `undefined`, or hole (missing element) is replaced with `{ isPrimaryOwner: 'false' }`
             * - Valid objects are kept as-is
             * - `Array.from` is used to handle sparse arrays correctly
             */
            const updatedArr = Array.from(ownerArray, (item:any,index:number) =>
                item == null ? { isPrimaryOwner: 'false' } : item
            );
            const coOwner:any = updatedArr.filter((x:any)=> (!x.isPrimaryOwner || x.isPrimaryOwner === 'false') );         
            return coOwner && coOwner?.length ? coOwner.map((data: any) => {
                 let _mailingAddress: any = data.mailingAddress;
                 _mailingAddress = _mailingAddress ? _mailingAddress[0] : {};
                   return {
                         "id":data.id?data.id:data.id,
                         "firstName": data.firstName ? data.firstName : '',
                         "lastName": data.lastName ? data.lastName : '',
                         "middleName": data['middleName'] ? data['middleName'] : '',
                         "email": data.email ? data.email : '',                         
                         "dob": data.dob ? data.dob : '',
                         "ssn": data?.ssn || data?.last4ssn || '',
                         "itin": data?.taxIdentification?.id || data?.taxIdentification?.idLast4 || '', 
                         "address_id": _mailingAddress.id ? _mailingAddress.id : '',
                         "addressLine1": _mailingAddress.addressLine1 ? _mailingAddress.addressLine1 : '',
                         "addressLine2": _mailingAddress.addressLine2 ? _mailingAddress.addressLine2 : '',
                         "city": _mailingAddress.city ? _mailingAddress.city : '',
                         "state": _mailingAddress.state ? _mailingAddress.state : '',
                         "zip": _mailingAddress.zip ? _mailingAddress.zip : '',
                         "mobilePhone": data.mobilePhone ? origin === 'autoSavedData' ? convertToPhoneRequestFormat(data.mobilePhone) : convertToPhoneDisplayFormat(data.mobilePhone) : '',
                        }
             }) : []
     }


        /**
         * This method used to set customer details as the format of form data
         */
        function getCustomerDetailsDataFromApi(data: any) {

            const customer = data.owners.find((x:any)=>x.isPrimaryOwner);            
            let _mailingAddress: any = customer.mailingAddress;
            _mailingAddress = _mailingAddress ? _mailingAddress[0] : {};
            return  {
                "id":customer['id'],
                "email": customer['email'],
                "mobilePhone": convertToPhoneDisplayFormat(customer['mobilePhone']),
                "firstName": customer['firstName'],
                "lastName": customer['lastName'],
                "middleName": customer['middleName'] ? customer['middleName'] : '',
                "dob": customer['dob'],
                "ssn": customer?.ssn || customer?.last4ssn || '',
                "itin": customer?.taxIdentification?.id || customer?.taxIdentification?.idLast4 || '', 
                "address_id": _mailingAddress.id ? _mailingAddress.id : '',
                "addressLine1": _mailingAddress['addressLine1'],
                "addressLine2": _mailingAddress['addressLine2'] ? _mailingAddress['addressLine2'] : '',
                "city": _mailingAddress['city'],
                "state": _mailingAddress['state'],
                "zip": _mailingAddress['zip'],
                "mobilePhone-select": "+91",
            }
        }

        // Method handles the onsubmit event of the customer details form
        const getCustomerDetails = async (data: any, callback:any) => {
            const jointOwnerStateCopy = {...jointOwnerState?.data}
            jointOwnerStateCopy['primaryOwnerData'] = data;
            const formReqCopy = signUpJointTenancy({ details: data })

            const req ={...formReqCopy.customer};
            const url:any="customer/id/" + getKey('customerId');
            await callAPI(url, Method.POST, req)
            callback()
            updateComponentParams(dispatch, props.id, { primaryOwnerData: data, step: 2, formReq: formReqCopy })
            updateCustomerKycJointOwnersData(dispatch, jointOwnerStateCopy);
        }


        // Method handles the onsubmit event of the review & submit page
        const handleReviewJointTenancySubmit = (req:any) => {           
            const customerType ={
                customer:{
                    type: "JOINT_TENANCY",
                }
            };

            const request = {...customerType, ...req};


          const linkedDocuments = req.fileData?.map((file: IFileInfo) => {
            return {
              purpose: 'AUTHORIZATION',
              document: {
                type: file?.fileType,
                name: file?.fileType === 'RATE_CARD' ? 'RATE_CARD.pdf' : 'KYC_AGREEMENT.pdf',
                base64encodedContent: file?.base64
              }
            }
          })

          let accountData: any = {
                "isCustomerOwned": true,
                "linkedDocument": linkedDocuments
            }
            if(paymentIdDetailReq?.nickname){
                accountData = {
                    ...accountData,
                    "nickName" : paymentIdDetailReq?.nickname
                }
            }

            request['account'] = accountData
            reviewJointTenancySubmitRequest(request)
        }

        async function reviewJointTenancySubmitRequest(req:any){
            let status:any = false;
            if(isUpdateContactRequest){
                status = true;
            }

            if(!status){
                status = await transformRequest(req)
            }
        }

        // Method transforms the request from various pages for api call
        async function transformRequest(req: any) {
            updateComponentParams(dispatch, props.id, { isLoading: true })
            delete req['privacyPolicyAccepted'];
            delete req['fileData'];
            delete req['accountNickname'];
            let status: any;
            status = await updateCustomer(req);
            status = processAPIResponse(status)
            if (status.status) {
                removeCookieCustom('customerKycData')
                // configuring gtm for kyc successful submit
                    const gtmData ={
                        event:"userKycSuccessTrigger",
                        "userEmail": getKey('email'),
                        "userType": "JOINT_TENANCY"
                    }
                    pushGTM(gtmData)
                setKey('kycPending','true');
                    updateComponentParams(dispatch, props.id, { isLoading: false, isUpdateContactRequest: true })
                    setTimeout(() => {
                        setLocalStorage('signUpFlow',undefined);
                        history.push('/home')
                    }, 1000);
            }
            else {
                //api  failed
                setLocalStorage('signUpFlow',undefined);
                updateComponentParams(dispatch, props.id, { isLoading: false })
                FxSnackBar.show({
                    text: status.message,
                });
                return false;
            }
        }

        /**
        * API call function
        * @param req :request
        * @returns
        */
        async function updateCustomer(req: any) {
            try {
                const data: any = await httpClient.post(getCustomerUrl('/onboard',false), req).then(response => {
                    return response
                })
                    .catch((error) => {
                        return { ...error };
                    })
                return data;
            } catch (err) {
                return err;
            }
        }

        // Method handles navigation from the review screen to the payment PPI screen
        const handleReview = (step?: number) => {
            // Determine the target step: use the provided 'step' or default to 2
            const targetStep = step ?? 2; // Using nullish coalescing operator for conciseness

            // Update the component's parameters to trigger navigation and data fetching
            updateComponentParams(dispatch, props.id, { step: targetStep, fetchIds: true });
        };

        /**
         * Handles the review process for a multi-step form.
         * 
         * @param {number} [step] - The current step in the review process. If not provided, defaults to 2.
         * 
         * Validates the forms for the specified step and updates their validity status.
         * If step is 2, only validates the jtIdentificationForm.
         * If step is 3, validates both jtIdentificationForm and jtCoOwnerForm.
         */
        const sideBarHandleReview = async (step?: number) => {
            // Determine the target step, defaulting to 2 if 'step' is not provided
            const targetStep = step ?? 2;

            // Call the function to handle data saving before navigating
            // Note: 'currentPage' was undefined in the original. Ensure it's correctly sourced
            // if its value is needed for handleDataSaveOnSectionChange.
            // Otherwise, consider if it's truly necessary or if the logic needs adjustment.
            handleDataSaveOnSectionChange(targetStep);

            // Update the component's parameters to trigger navigation to the target step
            updateComponentParams(dispatch, props.id, { step: targetStep });
        };

        /**
         * This method basically calls the respective form submission apis
         * whenever the User tries to navigate thru the Left Panel
         * @param step 
         * @param currentPage 
         */
        const handleDataSaveOnSectionChange = async (step: any, currentPage?: any) => {
            const validateForm = async (formRef: any, keyName: string) => {
                const feedback = await formRef.current?.submitForm();
                setKey(keyName, feedback?.success ? 'valid' : 'invalid');
            };

            if(props?.step === 1){
                await validateForm(jtIdentificationForm, 'jtIdentificationForm');
            }else if(props?.step === 2){
                await validateForm(jtCoOwnerForm, 'jtCoOwnerForm');
            }
        }
        

        
        // Method handles the click event of menu bar
        const handleMenuClick = (step: any) => {
            updateComponentParams(dispatch, props.id, { step })

        }

         // Method handles the click event of the beneficial owner page to move to the next screen
         const handleNextScreen = async (callback:any) => {
            let benOwnerReq = jointOwnerState?.data?.beneficialCoOwnerReq ? [...jointOwnerState?.data?.beneficialCoOwnerReq] : [];

            if(benOwnerReq.length === 0){
                updateComponentParams(dispatch, 'fx-signup-join-tenancy-co-owner-details', { isLoading: false })
                updateComponentParams(dispatch, props.id, { step: 3 });

                return;
            }

            const updatedBenOwnerReq = benOwnerReq.filter(obj =>obj && Object.keys(obj).length !== 0).map((item: any) => {
                const { address_id, actionIndex, ...rest } = item || {};
                return rest;
              });

            benOwnerReq = updatedBenOwnerReq; 
            
            /**
             *  To update beneficial owners by removing 'ssn' property for items with SSN length less than 10.
             * @param {object} req - The request object containing beneficial owner information.
             * @returns {Array} - An array of updated beneficial owners.
             */
            const updatedBeneficialOwners = (benOwnerReq || []).map((item: any) => {
                if ((item?.ssn && item.ssn.length < 10) || item.ssn === '') { 
                    // Create a new object without the 'ssn' property
                    const { ssn, actionIndex, ...updatedItem } = item;
                    return updatedItem;
                }
                if ((item?.itin && item.itin.length < 10) || item.itin === '') {
                    // Create a new object without the 'itin' property
                    const { itin, actionIndex, ...updatedItem } = item;
                    return updatedItem;
                } else if (item?.itin) {
                    const { itin, ...updatedItem } = item;
                    updatedItem['taxIdentification'] = {
                        id: itin,
                        type:'ITIN'
                    }
                    return updatedItem;  
                }
                return item;
            });

            benOwnerReq = updatedBeneficialOwners;            
           
            const req:any = {
                type: "JOINT_TENANCY",
                isKycUpdate: true,
                owners: [...benOwnerReq], 
            }

            const url:any="customer/id/" + getKey('customerId');
            let status = await callAPI(url, Method.POST, req)
            status = processAPIResponse(status)
            callback()
            if (status.status) {  
                
                resetCoOwnerDetails();
                updateComponentParams(dispatch, 'fx-signup-join-tenancy-co-owner-details', { isLoading: false })
                updateComponentParams(dispatch, props.id, { step: 3 })
            }
            else {
                //api  failed
                FxSnackBar.show({
                    text: status.message,
                });
            }
        }

        // Method to refersh customer details
        const resetCoOwnerDetails=()=>{                  
            const dataCopy = {...jointOwnerState?.data}            
            dataCopy['beneficialCoOwnerReq'] = [];
            updateCustomerKycJointOwnersData(dispatch, dataCopy);
            
            dispatch({type: 'DATA_API_PARAM_CHANGED', payload: {id: `joint-tenancy-user-signup`, source: { url: `/`,method: "GET"}} });  
        }

         // Method handles the going back from review screen to joint owner details screen
         const handleBeneficialCoOwner = () => {
            updateComponentParams(dispatch, props.id, { step: 1 })

        }

         /**
         * update request and data after remove owner
         * @param index :index
         * @param data :data
         */
         const updatedBusinessOwnerData= async (index:any,data:any) =>{
            const reqArray = jointOwnerState?.data?.beneficialCoOwnerReq?.length > 0? [...jointOwnerState?.data?.beneficialCoOwnerReq]: []
            if(index !== -1){
                reqArray.splice(index, 1);
            }
           
            const dataCopy = {...jointOwnerState?.data}
            dataCopy['beneficialCoOwnerData'] = data;
            dataCopy['beneficialCoOwnerReq'] = reqArray;
            updateCustomerKycJointOwnersData(dispatch, dataCopy);
            
            //Passing the index of the BO that needs to be removed
            let req: any;
            let finalIndex: any = index+1;
            req = {
                "deleteNode" : `owners[${finalIndex}]`
            };

            await updateOnboardingFormData(req);

            //Calling the GET AutoSave Details API and saving the data in the autoSavedData
            const previouslySavedData = await getAutosavedDataFromOnboardingFormDataApi();
            if (previouslySavedData && previouslySavedData?.data && previouslySavedData?.data?.flatFields) {
                const objectFormatData: any = unflattenObject(previouslySavedData.data.flatFields);
                const formattedData = getBODetailsDataFromApi(objectFormatData, 'autoSavedData');
                updateComponentParams(dispatch, props?.id, { autoSavedData: formattedData.filter((item: any) => item !== undefined).slice(1) });
            }
        }

        /**
         * Method to delete the particular BO from the autoSave API as well
         * @param req 
         * @returns 
         */

        // Method handles the onsubmit event of the beneficial owner page
        const handleBeneficialOwnerSubmit = (data: any, req: any, action: any, index: any) => {
            const benOwnerData = jointOwnerState?.data?.beneficialCoOwnerData.length > 0 ? [...jointOwnerState?.data?.beneficialCoOwnerData] : [];
            const benOwnerReq = jointOwnerState?.data?.beneficialCoOwnerReq?.length > 0? [...jointOwnerState?.data?.beneficialCoOwnerReq]: []
            let reqArray: any;
            let dataArray: any;
            
            if (action === 'add') {
                reqArray = [...benOwnerReq];
                reqArray[benOwnerData.length] = req;
                data.actionIndex = reqArray.length-1;
                dataArray = [...benOwnerData, data];
            }
            else {
                if (index !== undefined) {
                    reqArray = [...benOwnerReq];
                    dataArray = [...benOwnerData];
                    reqArray[index] = req;
                    data.actionIndex = index;
                    dataArray[index] = data;
                }
            }
            const dataCopy = {...jointOwnerState?.data}           
            dataCopy['beneficialCoOwnerData'] = dataArray;
            dataCopy['beneficialCoOwnerReq'] = reqArray;
            updateCustomerKycJointOwnersData(dispatch, dataCopy);


            // Calls the GET autoSave API again to fetch the latest set of data
            fetchLatestAutoSavedDetails(dataCopy);

        }

        /**
         * This method calls the  GET autoSave API again to fetch the latest set of data and saves the data in the autoSavedData state
         */
        const fetchLatestAutoSavedDetails = async (globalStateDataCopy: any) => {
            const previouslySavedData = await getAutosavedDataFromOnboardingFormDataApi();
            if (previouslySavedData && previouslySavedData?.data && previouslySavedData?.data?.flatFields) {
                const objectFormatData: any = unflattenObject(previouslySavedData.data.flatFields);
                const formattedData = getBODetailsDataFromApi(objectFormatData, 'autoSavedData');
                const mergedData = mergeBeneficialOwners(
                    formattedData.slice(1) ?? [],
                    globalStateDataCopy?.beneficialCoOwnerData
                    );
                updateComponentParams(dispatch, props?.id, { autoSavedData: mergedData.filter((item: any) => item !== undefined) });
            }
        }

        /**
         * useEffect to call the getCustomerApi when the mainMenu is 3
         */
        useEffect(()=>{
            if(props?.step === 2 && props?.fetchIds){
                callingGetCustomerApi();
            }
        },[props?.step, props?.fetchIds])

        /**
     * method used to call the get customer api
     */
    const callingGetCustomerApi = async () => {
        const customerBusinessData = await getBusinessOwnerDataFromApi();
        handlePostBODeletionActivity(customerBusinessData);
    }

    /**
     * Calling GET Customer API to fetch the business owner data
     */
    const getBusinessOwnerDataFromApi = async () => {
        try{
            const response = await httpClient.get(getCustomerUrl("", false));
            return response;
        }catch(e: any){
            Logger.error("BusinessOwnerCard.tsx", "getBusinessOwnerDataFromApi", "error", e);
        }
    }

    /**
    * method used to handle pre-populating customer info after the deletion of beneficial owner
    */
    const handlePostBODeletionActivity= (customerBusinessData: any)=> {
        let beneficialOwnerData: any;
        
        const detailedBusinessInfo: any = customerBusinessData.data?.owners;

        const data =  getBODetailsDataFromApi(customerBusinessData !== undefined ? customerBusinessData?.data :[]);
        beneficialOwnerData = data;

        updateComponentParams(dispatch, props?.id, { autoSavedData: beneficialOwnerData });

        if(Array.isArray(beneficialOwnerData))
            processAllBeneficialOwners(beneficialOwnerData);
    }


      const primaryOwnerData = jointOwnerState?.data?.primaryOwnerData || {};
      const coOwnerData = jointOwnerState?.data?.beneficialCoOwnerData || [];



      // Primary owner details for the review screen
         const ssn = getLastFourDigits(primaryOwnerData.ssn);
         const itin = getLastFourDigits(primaryOwnerData.itin);
      const primaryOwnerInfo: ICardData = {
        header: 'Primary Owner Information',
        items: [{
          name: `${primaryOwnerData.firstName ?? ''} ${primaryOwnerData.lastName ?? ''}`,
          data: {
            ein: {
              title: 'EIN:',
              value: primaryOwnerData.ein || ''
            },
            ...(itin ? { itin: { title: 'ITIN', value: `${itin ? '*' + itin : ''}` } } :
            { ssn: { title: 'SSN', value: `${ssn ? '*' + ssn : ''}` } }),
            address: {
              value: `${primaryOwnerData.addressLine1 || ''} ${primaryOwnerData.addressLine2 || ''}${primaryOwnerData.city ? ', ' + primaryOwnerData.city : ''}${primaryOwnerData.state ? ', ' + primaryOwnerData.state : ''}${primaryOwnerData.zip ? ', Zip - ' + primaryOwnerData.zip : ''}`
            },
            email: {
              value: primaryOwnerData.email || ''
            }
          }
        }]
      }

      // co-owner details for the review screen
      const coOwnerInfo: ICardData = useMemo(()=>{
        return {
            header: 'Co-Owner Information',
        items: coOwnerData && coOwnerData.length>0 && coOwnerData?.map((coOwner: any, index: number) => {
          const ssn = getLastFourDigits(coOwner?.ssn);
          const itin = getLastFourDigits(coOwner?.itin);
          return {
            name: `${coOwner?.firstName ?? ''} ${coOwner?.lastName ?? ''}`,
            index: index + 1,
            data: {
              ...(itin ? { itin: { title: 'ITIN', value: `${itin ? '*' + itin : ''}` } } :
              { ssn: { title: 'SSN', value: `${ssn ? '*' + ssn : ''}` } }),
              address: {
                value: `${coOwner?.addressLine1 || ''} ${coOwner?.addressLine2 || ''}${coOwner?.city ? ', ' + coOwner?.city : ''}${coOwner?.state ? ', ' + coOwner?.state : ''}${coOwner?.zip ? ', Zip - ' + coOwner?.zip : ''}`
              },
              email: {
                value: coOwner?.email || ''
              },
            }
          }
        })}
       }, [jointOwnerState?.data?.beneficialCoOwnerData])

      // Review details for the review screen
      const reviewDetails = [
        { info: primaryOwnerInfo, step: 1 },
        { info: coOwnerInfo, step: 2 },
      ]


      /**
         * This method decides which BO List to be shared with the child components on the basis of the data present inside them
         */
        const businessOwnerComponentData = useMemo(() => {
            if ((props?.autoSavedData?.length >= jointOwnerState?.data?.beneficialCoOwnerData?.length)) {
                return (props?.autoSavedData);
            }else{
                return jointOwnerState?.data?.beneficialCoOwnerData;
            }

        }, [props?.autoSavedData, jointOwnerState?.data?.beneficialCoOwnerData])

        return (
            <Grid item xs={12} container direction="row"  className='fx-form-grid fx-join-tenancy-co-owner'>
                {!isSmallScreen && <Grid item xs={3} sm={4} md={3} container direction="row" alignContent="flex-start"    className ="fx-login-promo-parent">
                    <JointTenancySignUpLeftBar activeMenu={step} onClick={handleMenuClick} goBackClick={sideBarHandleReview} data={jointOwnerState?.data?.primaryOwnerData} />
                </Grid>}
                {isSmallScreen && <Grid item xs={12} md={12} sm={12} container direction="row" alignContent="flex-start"  className ="fx-login-promo-parent">
                    <JointTenancySignUpLeftBar activeMenu={step} onClick={handleMenuClick} data={jointOwnerState?.data?.primaryOwnerData} />
                </Grid>}
                {initialIndData && props?.primaryOwnerData &&<Grid className={`left-sidebar-signup ${step === 1 ? 'active' : ''}`} item xs={12} sm={isSmallScreen?undefined:8} md={isSmallScreen?undefined:9} container direction="row">
                    <JointTenancyIdentificationSignUp id='fx-signup-join-tenancy-details' ref={jtIdentificationForm} onSubmit={getCustomerDetails} data={jointOwnerState?.data?.primaryOwnerData} />
                </Grid >}
                {<Grid className={`left-sidebar-signup ${step === 2 ? 'active' : ''}`} item xs={12} sm={isSmallScreen?undefined:8} md={isSmallScreen?undefined:9} container direction="row" alignContent="flex-start">
                    <JointTenancyCoOwnerCard id='fx-signup-join-tenancy-co-owner-details' ref={jtCoOwnerForm} primaryOwnerDetails={jointOwnerState?.data?.primaryOwnerData} updatedData={updatedBusinessOwnerData} onSubmit={handleBeneficialOwnerSubmit} data={businessOwnerComponentData} onClick = {handleNextScreen} goBackClick={handleBeneficialCoOwner} />
                </Grid >}
                {<Grid className={`left-sidebar-signup ${step === 3 ? 'active' : ''}`} item xs={12} sm={isSmallScreen?undefined:8} md={isSmallScreen?undefined:9} container direction="row" alignContent="flex-start">
                    <ReviewAndSubmitSignup reviewDetails={reviewDetails} goBackClick={handleReview} onSubmit={handleReviewJointTenancySubmit} loading={isLoading} />
                </Grid >}
            </Grid >
        );
});


